import { ReactElement, useState } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import classnames from 'classnames';
import FieldWrapper from '../FieldWrapper';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import classes from './SearchBox.module.scss';
import useFormInput from '../../../utils/hooks/useFormInput';
import TextField from '../../UI/MDC/TextField/TextField';
import { LABEL_POSITIONS } from '../_constants';

/**
 * Text-based input that displays options that it searches for which is Formik-compliant
 * @param {*} properties needed by TextBox including but not limited to label, options, onSearch handler
 * @returns {ReactElement} SearchBox Field component
 */
const SearchBox = ({ label, options, onSearch, ...props }) => {
	const {
		field,
		meta,
		onChange,
		setValue,
		additionalProps: { labelPosition, ...additionalProps },
	} = useFormInput(props);

	const [showOptions, setShowOptions] = useState(false);

	return (
		<FieldWrapper
			label={'Find ' + label}
			field={field}
			meta={meta}
			additionalProps={{
				labelPosition: labelPosition,
				...additionalProps,
			}}
			hideErrorMessage
		>
			<StyleAuxiliary
				classes={classnames(classes['form-element__searchbox'])}
			>
				<TextField
					{...field}
					{...additionalProps}
					inputProps={{
						...additionalProps.inputProps,
						autoComplete: 'off',
					}}
					onFocus={e => {
						setShowOptions(true);
						!!field && !!field.onFocus && field.onFocus(e);
						!!additionalProps.onFocus && additionalProps.onFocus(e);
					}}
					onBlur={e => {
						setShowOptions(false);
						!!field && !!field.onBlur && field.onBlur(e);
						!!additionalProps.onBlur && additionalProps.onBlur(e);
					}}
					onChange={e => {
						onChange(e);
						if (e.target?.value && onSearch) {
							onSearch(e.target.value);
						}
					}}
					className={classnames([classes['form-element__textfield']])}
					help={additionalProps.help ? additionalProps.help : ' '}
					label={'Type to search...'}
				/>
				<StyleAuxiliary
					classes={classnames(
						classes['form-element__autocomplete-options-container']
					)}
				>
					<StyleAuxiliary
						classes={classnames(
							classes['form-element__autocomplete-options'],
							classes[
								'form-element__autocomplete-options--' +
									(props.labelPosition
										? props.labelPosition
										: LABEL_POSITIONS.TOP)
							]
						)}
					>
						{showOptions &&
							options &&
							options.map(opt => {
								return (
									<div
										key={nanoid()}
										onMouseDown={() => {
											!!setValue && setValue(opt);
											!!onChange &&
												onChange({
													target: { value: opt },
												});
										}}
									>
										{opt}
									</div>
								);
							})}
					</StyleAuxiliary>
				</StyleAuxiliary>
			</StyleAuxiliary>
		</FieldWrapper>
	);
};

SearchBox.propTypes = {
	label: PropTypes.string.isRequired,
	onSearch: PropTypes.func.isRequired,
	options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SearchBox;
